import React from 'react';
import { expandString } from '@app/helpers';

interface IProps {
    isNeedExpandToken: boolean;
    encodedKey: string;
}

export const SetUpDeviceExpandToken: React.SFC<IProps> = ({
    isNeedExpandToken,
    encodedKey,
}) => {
    return (
        <div className='manage-mfa-token__manual-token'>
            <span>{isNeedExpandToken ? expandString(encodedKey, 4) : encodedKey}</span>
        </div>
    );
};
